import { Button } from '@bizora/ui'
import { ExternalLink } from 'lucide-react'

export function Demo() {
  const demoTenants = [
    { slug: 'bakers', name: 'Cake&Bake', description: 'Bakery business demo' },
    { slug: 'laundry-royal', name: 'WashPure', description: 'Laundry service demo' },
    { slug: 'aquapure', name: 'Aquapure', description: 'Water bottling and distribution company demo' }
  ]

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="text-center mb-16">
          <h1 className="text-5xl font-bold text-neutral-900 mb-4">Try Our Demo</h1>
          <p className="text-xl text-neutral-600">
            Explore live demos of Bizora in action
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {demoTenants.map((tenant) => (
            <div key={tenant.slug} className="bg-neutral-50 p-8 rounded-xl border border-neutral-200">
              <h2 className="text-2xl font-semibold text-neutral-900 mb-2">{tenant.name}</h2>
              <p className="text-neutral-600 mb-6">{tenant.description}</p>
              <div className="flex gap-4">
                <a
                  href={`http://localhost:3001?tenant=${tenant.slug}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Button>
                    View Customer Store
                    <ExternalLink className="w-4 h-4 ml-2" />
                  </Button>
                </a>
                <a
                  href={`http://localhost:3000?tenant=${tenant.slug}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Button variant="ghost">
                    View Admin Panel
                    <ExternalLink className="w-4 h-4 ml-2" />
                  </Button>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
  )
}

